export default {
    data() {
        return {
            baseUri: window.addiesaas.config.baseUri,
        }
    }
}
